import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../../../components/buttons/customButton';
import { useSyncOrganizationByDateRange } from '../../../apiHooks/mutations/internalSync/useSyncOrganizationByDateRange';
import { useSyncFsToAdsManually } from '../../../apiHooks/mutations/internalSync/useSyncFsToAdsManually';
import {
  InternalDateRangePickerBar,
  useInternalDateRange,
} from '../internalDateRangePickerBar';

interface SyncItem {
  titleKey: string;
  endpoint: string;
  onSync: () => void;
  isLoading: boolean;
}

const SyncTabPanel = () => {
  const { t } = useTranslation();
  const {
    filterRange,
    setFilterRange,
    isCalendarOpen,
    setIsCalendarOpen,
    dateRangeParams,
    isDateRangeValid,
  } = useInternalDateRange();

  const { mutate: syncOrganizationByDateRange, isLoading: isBuildingAds } = useSyncOrganizationByDateRange();
  const { mutate: syncFsToAdsManually, isLoading: isSyncingFsToAds } = useSyncFsToAdsManually();

  const syncItems: SyncItem[] = [
    {
      titleKey: 'rebuildAdsForDateRange',
      endpoint: 'digger-core-api/ad/build/manual',
      onSync: () => syncOrganizationByDateRange(dateRangeParams),
      isLoading: isBuildingAds,
    },
    {
      titleKey: 'linkFormSubmissionsToAds',
      endpoint: 'digger-core-api/ad/sync/manual',
      onSync: () => syncFsToAdsManually(dateRangeParams),
      isLoading: isSyncingFsToAds,
    },
  ];

  return (
    <div>
      <InternalDateRangePickerBar
        dataCy="internal-sync-date-toggle"
        filterRange={filterRange}
        setFilterRange={setFilterRange}
        isCalendarOpen={isCalendarOpen}
        setIsCalendarOpen={setIsCalendarOpen}
      />
      <div className="flex flex-col gap-4">
        {syncItems.map((item) => (
          <div
            key={item.titleKey}
            className="flex items-center justify-between gap-5 rounded-xl border p-4"
          >
            <div className="flex flex-col gap-1">
              <p className="text-sm font-[500] text-primary">{t(item.titleKey)}</p>
              <p className="text-xs text-gray-3">{item.endpoint}</p>
            </div>
            <CustomButton
              disabled={item.isLoading || !isDateRangeValid}
              className="h-[40px] px-[20px] text-sm"
              onClick={item.onSync}
            >
              {t('sync')}
            </CustomButton>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SyncTabPanel;
